import React, { useMemo } from 'react';
import { Spin, Alert } from "antd";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../../store/actions";
import { useForm } from 'react-hook-form';
import Form from '../Form/Form';
import FormButtons from '../FormButtons/FormButtons';
import Fieldset from '../FormFieldset/FormFieldset';
import { isObjectNotEmpty } from '../../shared/objectUtils';

const RemoveDocument = ({ document, cancel }) => {
    const methods = useForm({ mode: 'all', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.documents.isRecordUpdateLoading);
    const error = useSelector(state => state.documents.updateRecordError);

    const onSubmit = () => {
        let payload = {};
        payload.isDeleted = true;
        payload.entityId = document.entityId;
        payload.entityType = document.entityType;

        if (isObjectNotEmpty(payload)) {
            dispatch(actionCreators.updateDocument(document.id, payload));
        }
    };

    const onCancel = () => {
        dispatch(actionCreators.updateDocumentCancel());
        cancel();
    };

    useMemo(() => {
        // clear any previous errors if this is a new form
        dispatch(actionCreators.updateDocumentErrorClear());
    }, []);

    useMemo(() => {
        if (isLoading !== null && isLoading === false && error === null) {
            onCancel();
        }
    }, [isLoading, error]);

    return (
        <Form onSubmit={methods.handleSubmit(onSubmit)}>
            <Spin style={{ height: '100%', width: '100%' }} size="large" spinning={isLoading === true && error === null}>
                <Fieldset legend="Remove Document (this will delete the document from the system)">
                    <div><b>Are you sure you want to Delete this Document? This cannot be undone.</b></div>
                </Fieldset>
                {error && <Alert message={`${error}`} type="error" />}
            </Spin>
            <FormButtons cancel={onCancel} disabled={isLoading === true && error === null} submitText="Delete Document" />
        </Form>
    );
};

export default RemoveDocument;